module.exports = __webpack_public_path__ + "static/media/Heart.c8e0933f.jpg";